export interface YouTubeVideoMetadata {
  title?: string;
  thumbnailUrl?: string;
}

interface YouTubeOEmbedResponse {
  title?: unknown;
  thumbnail_url?: unknown;
}

export const getDefaultYouTubeThumbnailUrl = (videoId: string): string =>
  `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

export async function fetchYouTubeVideoMetadata(
  videoId: string
): Promise<YouTubeVideoMetadata | null> {
  const canonicalUrl = `https://www.youtube.com/watch?v=${videoId}`;
  const endpoint =
    `https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(canonicalUrl)}`;

  try {
    const response = await fetch(endpoint, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as YouTubeOEmbedResponse;
    const title = typeof data.title === 'string' ? data.title.trim() : '';
    const thumbnailUrl = typeof data.thumbnail_url === 'string' ? data.thumbnail_url.trim() : '';

    if (!title && !thumbnailUrl) {
      return null;
    }

    return {
      ...(title ? { title } : {}),
      ...(thumbnailUrl ? { thumbnailUrl } : {})
    };
  } catch (error) {
    console.warn('Failed to fetch YouTube metadata:', error);
    return null;
  }
}
